<form (submit)="sign()" novalidate>
    @if (authenticationRequest()) {
        <div class="ap-digipas ap-grid">
            <div>
                @if (isAnonymous()) {
                    <strong>{{ 'digipas.select.token.anonymous' | apContent }}</strong>
                    <ap-input
                        data-bb="tokenIdInput"
                        [formControl]="signResponse.get('keyID') | apFormControl"
                        inputmode="numeric"
                        [label]="'digipas.select.tokenId' | apContent"
                        (inputBlur)="onBlur()"
                        [messages]="keyIdErrorMessages"
                        [helpText]="'digipas.select.tokenId.info' | apContent"
                    >
                    </ap-input>
                } @else {
                    <strong>{{ 'digipas.select.token.loggedIn' | apContent }}</strong>
                    @if (hasMultipleTokens()) {
                        <ap-dropdown
                            [label]="'digipas.select.tokenId' | apContent"
                            [formControl]="signResponse.get('keyID') | apFormControl"
                            [options]="keyIDs"
                        >
                        </ap-dropdown>
                    } @else {
                        <p>
                            <span>{{ 'digipas.select.tokenId' | apContent }}</span
                            >&nbsp;<span data-bb="tokenId">{{ signResponse.get('keyID').value }}</span>
                        </p>
                    }
                }
            </div>
        </div>
        @if (signResponse && signResponse.get('keyID').valid) {
            @if (saveTokenIdEnabled()) {
                <ap-checkbox [label]="'digipas.select.save' | apContent" [formControl]="saveDigipas"></ap-checkbox>
            }
            <ol>
                <li>
                    <span aria-hidden="true">
                        {{ 'digipas.instruction.content1' | apContent }}
                        <ap-icon name="digipas-back" size="small"></ap-icon>
                        {{ 'digipas.instruction.content2' | apContent }}
                    </span>
                    <span class="ap-sr-only">
                        {{ 'digipas.instruction.content1' | apContent }}
                        {{ 'digipas.instruction.aria.digipas-back' | apContent }}
                        {{ 'digipas.instruction.content2' | apContent }}
                    </span>
                </li>
                <li>{{ 'digipas.instruction.content3' | apContent }}</li>
                <li>
                    {{ 'digipas.instruction.content4' | apContent }}
                    <div class="ap-digipas__challenge">
                        <span class="ap-digipas__challenge-number">{{ challenge }}</span>
                        <span class="ap-digipas__challenge-icon" aria-hidden="true">
                            <ap-icon size="100%" color="inherit" name="digipas"> </ap-icon>
                        </span>
                        <ap-content class="ap-sr-only" key="digipas.challenge.constraint"></ap-content>
                    </div>
                </li>
                <li>
                    {{ 'digipas.response' | apContent }}
                    <div class="ap-digipas__response">
                        <ap-input
                            [label]="'digipas.response.number' | apContent"
                            inputmode="numeric"
                            data-bb="response"
                            [formControl]="signResponse.get('response') | apFormControl"
                            [maxlength]="6"
                            [messages]="responseErrorMessages"
                        >
                        </ap-input>
                    </div>
                </li>
            </ol>
        }
        <ng-container>
            <div class="ap-digipas__buttons">
                @if (cancelText()) {
                    <ap-button data-bb="cancel" variant="secondary" (onClick)="cancel()">
                        {{ cancelText() }}
                    </ap-button>
                }
                <ap-submit [canSign]="canSign" [submitText]="submitText()" (submitted)="sign()"></ap-submit>
            </div>
        </ng-container>
    }
</form>
